export class BatchRequestClientError extends Error {
  constructor(message, requestKeys) {
    super(message);
    this.requestKeys = requestKeys;
  }
}